<template>
  <div class="container">
    <Menu />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Menu from "../components/Menu";
import Footer from "../components/Footer";
export default {
  name: "LoginLayout",
  components: {
    Menu,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.container{
  min-height: 100%;
  background: #f0f2f5 url(/img/background.svg) no-repeat 50%;
}
.panel{
    // box-shadow: 0px 0px 11px 8px #00000036;
    // border-radius: 10px;
    padding: 20px;
    min-width: 260px;
    width: 468px;
    margin: 180px auto;
}
</style>